import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PillBugsContainer from './PillBugsContainer';
import { getUsersList } from '../../../../actions/Users/UserAction';

class PillBugs extends React.Component {

  onFilter = () => {
    this.props.onFilter ? this.props.onFilter(false) : void 0;
  };

  onRemove = (userSearchFilterKey) => () => {
    this.props.getUsersList({
      terms: {
        [userSearchFilterKey]: [],
      },
    });
  };

  renderPillBugs(name, userSearchFilterKey) {
    const pillsEnabled = this.props.pillsEnabled[name];
    return pillsEnabled ? (
      <PillBugsContainer
        name={name}
        userSearchFilterKey={userSearchFilterKey}
        onRemove={this.onRemove(userSearchFilterKey)}
      />
    ) : (
      void 0
    );
  }
  render() {
    return (
      <div className="pillbugs-container">
        {this.renderPillBugs('CAS', 'casId')}
        {this.renderPillBugs('Institution', 'institutionId')}
        {this.renderPillBugs('Organization', 'clientId')}
        {this.renderPillBugs('Role', 'userRoleId')}
        {this.renderPillBugs('Status', 'status')}
        {this.renderPillBugs('Internal', 'internalUser')}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    pillsEnabled: state.Users.usersPills,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getUsersList,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(PillBugs);
